import { useQuery } from '@apollo/client';

import type {
  GetPathwayDegreeByCourseIdQuery,
  GetPathwayDegreeByCourseIdQueryVariables,
} from 'bundles/promotions/queries/__generated__/getPathwayDegreeByCourseId';
import getPathwayDegreeByCourseIdQuery from 'bundles/promotions/queries/getPathwayDegreeByCourseId.graphql';

type DegreeByCourse = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<NonNullable<GetPathwayDegreeByCourseIdQuery['Course']>['queryById']>['pathwayProperties']
      >['degreePathways']
    >['elements']
  >[0]
>['degree'];
export type PropsFromUseGetDegreeUpsellByCourseId = {
  degreeByCourse?: DegreeByCourse | null;
};

const useGetDegreeUpsellByCourseId = ({ course, skip }: { skip?: boolean; course?: { id: string } }) => {
  const { data, loading } = useQuery<GetPathwayDegreeByCourseIdQuery, GetPathwayDegreeByCourseIdQueryVariables>(
    getPathwayDegreeByCourseIdQuery,
    {
      skip: skip || !course?.id,
      variables: { courseId: course?.id || '', cursor: '0', limit: 1 },
      context: { clientName: 'gatewayGql' },
    }
  );

  const degreeByCourse = data?.Course?.queryById?.pathwayProperties?.degreePathways?.elements?.[0]?.degree;

  return { degreeByCourse, loading };
};

export default useGetDegreeUpsellByCourseId;
